export const environment = {
  production: false,
  apiUrl:'https://id-test.medadvisor.io/PharmacyAdministration'
};
